import type { FusionConfig } from '@wf-coe/types';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

/** Wire-format Fusion config — Date fields are ISO strings. */
export type FusionConfigDto = Omit<FusionConfig, 'createdAt' | 'updatedAt'> & {
  createdAt: string;
  updatedAt: string;
};

/** Lists Fusion configs for a tenant. Disabled until api + clientId both available. */
export function useFusionConfigsQuery(
  clientId: string | undefined,
): UseQueryResult<FusionConfigDto[]> {
  const api = useApiClient();
  return useQuery({
    queryKey: ['fusion-configs', clientId],
    queryFn: () => {
      if (!api) throw new Error('useFusionConfigsQuery: api client unavailable');
      if (!clientId) throw new Error('useFusionConfigsQuery: clientId required');
      return api.get<FusionConfigDto[]>(`/v1/clients/${clientId}/fusion-configs`);
    },
    enabled: api !== undefined && clientId !== undefined,
  });
}
